import React, { createContext, useContext, useState } from "react";
import { Loader } from "@/components/loader/Loader";

interface LoaderContextType {
  showLoader: () => void;
  hideLoader: () => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const LoaderContext = createContext<LoaderContextType | undefined>(
  undefined,
);

export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loading, setLoading] = useState(false);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      {loading ? <Loader fullScreen /> : null}
    </LoaderContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useLoader = (): LoaderContextType => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader debe usarse dentro de LoaderProvider");
  }
  return context;
};
